export default function call(apiName, options) {
  // @ts-ignore
  if (my[apiName]) return my[apiName](options);
  // @ts-ignore
  return my.call(apiName, options);
}